import { List } from "@material-ui/core";
import React, { useCallback } from "react";
import { RouteComponentProps } from "react-router-dom";
import { ReportItem } from "./ReportItem";

interface Props extends RouteComponentProps {}

export const ReportsGrid = ({ history }: Props) => {
  const handleClick = useCallback(
    (reportName: string) => {
      history.push(`/reports/${reportName}`);
    },
    [history],
  );

  return (
    <List>
      {/* <ReportItem
          name="ifta-mileage"
          label="resources.reports.iftaMileage.name"
          description="resources.reports.iftaMileage.description"
          onClick={handleClick}
        />
        <ReportItem
          name="ifta-summary"
          label="resources.reports.iftaSummary.name"
          description="resources.reports.iftaSummary.description"
          onClick={handleClick}
        /> */}
      <ReportItem
        name="ifta-mileage-detail"
        label="resources.reports.iftaMileage.name"
        description="resources.reports.iftaMileage.description"
        onClick={handleClick}
      />
      <ReportItem
        name="ifta-mileage"
        label="resources.reports.iftaMileageBasic.name"
        description="resources.reports.iftaMileageBasic.description"
        onClick={handleClick}
      />
      <ReportItem
        name="ifta-summary"
        label="resources.reports.iftaSummary.name"
        description="resources.reports.iftaSummary.description"
        onClick={handleClick}
      />
      <ReportItem
        name="vehicle-distance"
        label="resources.reports.vehicleDistance.name"
        description="resources.reports.vehicleDistance.description"
        onClick={handleClick}
      />
      <ReportItem
        name="vehicle-inactivity"
        label="resources.reports.vehicleInactivity.name"
        description="resources.reports.vehicleInactivity.description"
        onClick={handleClick}
      />
      <ReportItem
        name="locations-history"
        label="resources.reports.locationsHistory.name"
        description="resources.reports.locationsHistory.description"
        onClick={handleClick}
      />
      <ReportItem
        name="eld-events"
        label="resources.reports.eldEvents.name"
        description="resources.reports.eldEvents.description"
        onClick={handleClick}
      />
      <ReportItem
        name="daily-logs"
        label="resources.reports.dailyLogs.name"
        description="resources.reports.dailyLogs.description"
        onClick={handleClick}
      />
      <ReportItem
        name="dvir-history"
        label="resources.reports.dvirHistory.name"
        description="resources.reports.dvirHistory.description"
        onClick={handleClick}
      />
      <ReportItem
        name="trip-report-detail"
        label="resources.reports.tripReportDetail.name"
        description="resources.reports.tripReportDetail.description"
        onClick={handleClick}
      />
      <ReportItem
        name="trip-detail"
        label="resources.reports.tripDetail.name"
        description="resources.reports.tripDetail.description"
        onClick={handleClick}
      />
      <ReportItem
        name="safety-report"
        label="resources.reports.safety.name"
        description="resources.reports.safety.description"
        onClick={handleClick}
      />
      <ReportItem
        name="fuel-economy"
        label="resources.reports.fuelEconomy.name"
        description="resources.reports.fuelEconomy.description"
        onClick={handleClick}
      />
      <ReportItem
        name="harsh-driving"
        label="resources.reports.harshDriving.name"
        description="resources.reports.harshDriving.description"
        onClick={handleClick}
      />
      <ReportItem
        name="idle-reports"
        label="resources.reports.idleReports.name"
        description="resources.reports.idleReports.description"
        onClick={handleClick}
      />
    </List>
  );
};
